<template>
  <div v-if="isUser">
    <CDropdown
        inNav
        class="c-header-nav-items"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar">
            <CIcon name="cil-bell"/><CBadge variant="light" style="color: red">{{ notifications.length }}</CBadge>
          </div>
        </CHeaderNavLink>
      </template>

      <CDropdownHeader
          tag="div"
          class="text-center"
          color="light"
      >
        <strong>Notifications</strong>
      </CDropdownHeader>
      <div v-for="(message, index) in messages" v-bind:key="index">
        <CDropdownItem>
          <p>{{ message }}</p>
        </CDropdownItem>
        <CDropdownDivider/>
      </div>
    </CDropdown>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TheNotificationDropdown",
  data () {
    return {
      notifications: [],
      messages: [],
      isUser: true
  }
  },
  mounted() {
    const role = localStorage.getItem("roles")
    if (role === 'superadmin' || role === 'admin') {
      this.isUser = false
    } else {
      this.getNotification()
      this.twiceInADay()
    }
  },
  methods: {
    getNotification () {
      let self = this;
      const token = localStorage.getItem("api_token")
      const company_id = localStorage.getItem("company_id")
      axios.get(this.$apiAdress + '/api/notifications/' + company_id, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('notifications', response.data.data)
        self.notifications = response.data.data
        self.setMessage()
      }).catch(function (error) {
        console.log(error);
      });
    },
    setMessage() {
      let self = this
      for (let i =0; i < self.notifications.length; i++) {
        let title = 'A question inside ' + self.notifications[i].questionnaire_id + ' has been changed'
        self.messages.push(title)
      }
    },
    twiceInADay() {
      let self = this
      setInterval(function () {
        self.getNotification()
      }, 12*60*60*100000)
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
